<ag-grid-angular #machinesGrid class="ag-theme-vdw" appDataCy="machines-list" [gridOptions]="gridOptionsForMachines" [rowData]="listOfMachines"></ag-grid-angular>
